import { render, staticRenderFns } from "./deduplicationiplog-add-or-update.vue?vue&type=template&id=271a2da4&"
import script from "./deduplicationiplog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./deduplicationiplog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports